import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Helmet } from 'react-helmet';
import FooterIllustration from 'components/FooterIllustration';
import UnauthenticatedPage from 'components/UnauthenticatedPage';
import { TopNavbar } from 'components/Styles';
import MainSiteLogo from 'components/MainSiteLogo';
import { MobileApps } from 'services/Api';

const AppleIcon = () => (
  <svg className="ia-store__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      fill="currentColor"
      d="M16.37 12.6c-.02-2.3 1.88-3.4 1.96-3.46-1.07-1.56-2.73-1.78-3.32-1.8-1.41-.14-2.76.83-3.47.83-.72 0-1.82-.81-2.99-.79-1.54.02-2.96.9-3.75 2.27-1.6 2.78-.41 6.89 1.15 9.14.76 1.1 1.67 2.34 2.86 2.3 1.15-.05 1.58-.74 2.97-.74 1.38 0 1.77.74 2.98.72 1.23-.02 2.01-1.12 2.77-2.23.87-1.28 1.23-2.52 1.25-2.58-.03-.01-2.39-.92-2.41-3.66zM14.1 5.86c.63-.77 1.06-1.83.94-2.89-.91.04-2.02.61-2.67 1.37-.58.67-1.1 1.76-.96 2.8 1.02.08 2.06-.52 2.69-1.28z"
    />
  </svg>
);

const PlayIcon = () => (
  <svg className="ia-store__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path fill="#34a853" d="M4.2 2.3 13.7 12l-9.5 9.7c-.3-.2-.5-.6-.5-1.1V3.4c0-.5.2-.9.5-1.1z" />
    <path fill="#fbbc04" d="m16.9 15.2-3.2-3.2 3.2-3.2 3.8 2.2c1 .6 1 1.5 0 2.1l-3.8 2.1z" />
    <path fill="#ea4335" d="M16.9 15.2 13.7 12l-9.5 9.7c.4.4.9.4 1.6 0l11.1-6.5z" />
    <path fill="#4285f4" d="M16.9 8.8 5.8 2.3c-.7-.4-1.2-.4-1.6 0l9.5 9.7 3.2-3.2z" />
  </svg>
);

@inject('viewStore') @observer
class InvitationAccepted extends Component {
  openLogin = (event) => {
    // Plain clicks stay in the app; ctrl/cmd-click still opens a new tab.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    this.props.viewStore.login();
  };

  render() {
    return (
      <UnauthenticatedPage>
        <Helmet>
          <title>Invitation Accepted | FieldNexus</title>
        </Helmet>
        <TopNavbar>
          <div className="tp-nav">
            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-7">
                  <MainSiteLogo />
                </div>
              </div>
            </div>
          </div>
        </TopNavbar>
        <div className="form-wrap ia">
          <h3 className="login-heading">Invite accepted</h3>
          <p className="ia__lead">
            You've accepted your Field Nexus invite. Log in on the web, or get the
            mobile app to see your jobs on the go. Use the email and password you
            just set.
          </p>

          <div className="ia__actions">
            <a className="ia-button" href="/login" onClick={this.openLogin}>
              Log in to Field Nexus
            </a>
          </div>

          <h4 className="ia__subhead">Get the mobile app</h4>
          <div className="ia-stores">
            <a
              className="ia-store"
              href={MobileApps.ios.storeUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <AppleIcon />
              <span className="ia-store__text">
                <span className="ia-store__small">Download on the</span>
                <span className="ia-store__big">App Store</span>
              </span>
            </a>
            <a
              className="ia-store"
              href={MobileApps.android.storeUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <PlayIcon />
              <span className="ia-store__text">
                <span className="ia-store__small">Get it on</span>
                <span className="ia-store__big">Google Play</span>
              </span>
            </a>
          </div>
        </div>
        <FooterIllustration />
      </UnauthenticatedPage>
    );
  }
}

export default InvitationAccepted;
